import React from "react";
import "./ErrorModal.css";
// Icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
// Components
import { Dialog } from "@mui/material";

function SuccessModal({ text = "", hide = () => {} }) {
  return (
    <div className="error-modal-comp">
      <Dialog open={true} onClose={hide}>
        <div className="emc-dia">
          <div className="emc-close">
            <CloseIcon className="icon-cursor" onClick={hide} />
          </div>
          <CheckCircleIcon className="dg-icon big-red-icon" />
          <p>{text}</p>
        </div>
      </Dialog>
    </div>
  );
}

export default SuccessModal;
